import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import AdminSidebar from '../components/AdminSidebar';

const AdminContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f4f4f4;
`;

const Content = styled.div`
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
`;

const AdminLayout = () => {
  return (
    <AdminContainer>
      <AdminSidebar />
      <Content>
        <Outlet />
      </Content>
    </AdminContainer>
  );
};

export default AdminLayout;
